import { Box, Typography } from "@mui/material";

type StatusHistoryItem = {
  "Changed by": string;
  Date: string;
  Status: string;
};

const FormatStatusHistoryData = (statusData: string) => {
  const data: StatusHistoryItem[] = JSON.parse(statusData);

  return data.map((item) => {
    const uniqueKey = `${item["Changed by"]}-${item.Date}-${item.Status}`;

    return (
      <Box key={uniqueKey} mb={2} className="status-history">
        <Typography variant="h6">
          {item["Changed by"]} &nbsp;{item.Date}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Changed to : <span>{item.Status}</span>
        </Typography>
      </Box>
    );
  });
};

export default FormatStatusHistoryData;
